import React from "react";
import { DataViewGrid } from "../../../shared/components/DataView";
import { IInsuranceCoverage } from "../../../services/api/insurance/coverage/types";
import { mapInsuranceCoverageToDataView } from "../../Requirements/modules/SharedFile/configs/helpers/mapInsuranceCoverageToDataView";

export const InsuranceCoverageDataView: React.FC<{
  insuranceCoverage: IInsuranceCoverage;
}> = ({ insuranceCoverage }) => {
  return (
    <DataViewGrid
      data={mapInsuranceCoverageToDataView(insuranceCoverage)}
      fullWidth={false}
      gridColumns={3}
    />
  );
};
